

























































import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import backgroundImg from '@/assets/images/bg-2.jpg';
// @ts-ignore
import backgroundImgX2 from '@/assets/images/bg-2.jpg';

@Component({})
export default class EmailConfirmRequired extends Vue {
  public backgroundImage = backgroundImg;
  public backgroundImageX2 = backgroundImgX2;

}

